/**
 * Phase 2: Cloud Functions → daseruno-api REST 切替フィーチャーフラグ。
 *
 * これらは React Hook ではなく単なる関数。呼び出し時点の環境変数を毎回参照する。
 * いずれも未設定 (= undefined) の場合は false を返すため、デフォルトは旧 Cloud
 * Functions 経路となる (安全側)。
 */
export const isRestStripeEnabled = (): boolean =>
  process.env.REACT_APP_USE_REST_STRIPE === 'true'

export const isRestStaffEnabled = (): boolean =>
  process.env.REACT_APP_USE_REST_STAFF === 'true'

export const isRestOcrEnabled = (): boolean =>
  process.env.REACT_APP_USE_REST_OCR === 'true'

export const isRestSlackEnabled = (): boolean =>
  process.env.REACT_APP_USE_REST_SLACK === 'true'

/**
 * Phase 3: マスターデータ (ingredient_categories / sub_categories / additive_uses) を
 * daseruno-api から取得するかどうかを制御するフラグ。
 * true にすると Firestore ではなく REST API を参照する。デフォルト false (安全側)。
 */
export const isRestMasterEnabled = (): boolean =>
  process.env.REACT_APP_USE_REST_MASTER === 'true'
